import { PaginationResponse } from '@repo/ui/data-table'

import { Transfer } from '../../lib/types/models/transfer/transfer'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function getTransfers() {
  return restApiClient
    .url(constructApiUrl(API.transfer.getAll.url, null))
    .get<PaginationResponse<Transfer>>()
}
